const bundle = {
  close: () => 'Aizvērt',
  error: () => 'Kļūda',
  warn: () => 'Brīdinājums',
  info: () => 'Informācija',
  confirmation: () => 'Apstiprinājums',
  progressIndeterminate: () => 'Pašlaik notiek',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Starp ' + p['FROM_SECTION'] + ' un ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nav atrasta neviema atbilstoša sadaļa.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Nospiediet Enter, lai atlasītu vērtību.',
  indexer_touchInstructionText: () =>
    'Divreiz pieskarieties un turiet, lai ieietu žestu režīmā, tad velciet uz augšu vai uz leju, lai pielāgotu vērtību.',
  inputPassword_show: () => 'Rādīt paroli',
  inputPassword_hide: () => 'Paslēpt paroli',
  inputPassword_hidden: () => 'Parole paslēpta',
  formControl_clear: () => 'Notīrīt',
  formControl_loading: () => 'Ielādē',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Pārsniegts maksimālais garums ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Atlikušas ' + p['CHARACTER_COUNT'] + ' rakstzīmes.',
  select_noMatchesFound: () => 'Nav atrasta neviena atbilstība.',
  select_oneMatchFound: () => 'Atrasta viena atbilstība',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Atrastas ' + p['TOTAL_SIZE'] + ' atbilstības',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Atrastas ' + p['TOTAL_SIZE'] + ' vai vairāk atbilstību',
  selectMultiple_showSelectedValues: () => 'Rādīt tikai atlasītās vērtības.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Atlasītas ' + p['VALUE_COUNT'] + ' vērtības.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Izvēles rūtiņa ir atlasīta',
  selector_unselected: () => 'Izvēles rūtiņa nav atlasīta',
  userAssistance_learnMore: () => 'Uzzināt vairāk',
  userAssistance_required: () => 'Nepieciešams',
  filePicker_singleFileUploadError: () => 'Augšupielādējiet pa vienam failam',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nevar augšupielādēt failus ar tipu ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nevar augšupielādēt failus ar tipu: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'nezināms',
  filePicker_dropzonePrimaryText: () => 'Velciet un nometiet',
  filePicker_dropzoneSecondaryText: () => 'Atlasiet failu vai nometiet to šeit',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Atlasiet vai nometiet šeit failus',
  filePicker_addFiles: () => 'Pievienot failus',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Palielināt',
  inputNumber_decrease: () => 'Samazināt',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Nav vienumu, ko parādīt',
  message_navigationFromMessagesRegion: () =>
    'Notiek ieeja ziņojumu apgabalā. Nospiediet F6, lai naviģētu atpakaļ uz iepriekšējo fokusēto elementu.',
  message_navigationToMessagesRegion: () =>
    'Ziņojumu apgabalā ir jauni ziņojumi. Nospiediet F6, lai naviģētu uz visnesenāko ziņojumu apgabalu.',
  messageToast_allMessagesClosed: () => 'Visi uznirstošie ziņojumi ir aizvērti.'
};
export default bundle;
